import { CreateProvisionWasm } from "@pdfking/wasm-core"
import { BuildFSImports as build_imports } from "@pdfking/wasm-core/compatibility"
import wasm32 from "../wasm/ghostscript.wasm"
import { Functions } from "./Functions"

export const ProvisionWasm = CreateProvisionWasm(
  wasm32,
  { config: { build_imports } },
  Functions
)
